<template>
  <v-navigation-drawer
    v-model="drawer"
    :mini-variant="mini"
    mini-variant-width="120"
    width="240"
    app
    overlay
  >
    <!-- Profile -->
    <v-list nav>
      <div class="mx-5 my-5 d-flex justify-center align-center flex-column">
        <v-img
          max-height="60px"
          max-width="60px"
          src="@/assets/logo-sidebar.png"
          alt=""
          class="mb-2"
        />
        <h3
          class="text-center font-weight-light text-subtitle-1 mb-2"
          style="color: blue; line-height: 1; width: 80%"
          v-if="!mini"
        >
          National Virtual Adjuster
        </h3>
      </div>
      <v-list-item
        style="background-color: #2b58e2"
        :class="mini ? 'mx-5' : 'mx-7'"
        to="/settings"
        link
        active-class="active-class-profile"
      >
        <v-tooltip color="black" right :disabled="!mini">
          <template v-slot:activator="{ on, attrs }">
            <v-list-item-icon v-bind="attrs" v-on="on">
              <v-icon dark large>mdi-account-cog-outline</v-icon>
            </v-list-item-icon>
          </template>
          <span>{{ $t("sidebar.profile") }}</span>
        </v-tooltip>
        <v-list-item-content>
          <v-list-item-title style="color: white">{{
            $t("sidebar.profile")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :class="mini ? 'mx-5' : 'mx-7'"
        to="/newproject"
        link
        v-if="$store.getters.hasAcceptedTerms"
      >
        <v-tooltip color="black" right :disabled="!mini">
          <template v-slot:activator="{ on, attrs }">
            <v-list-item-icon class="mr-2" v-bind="attrs" v-on="on">
              <v-icon size="50" color="yellow darken-2">mdi-plus-circle</v-icon>
            </v-list-item-icon>
          </template>
          <span
            >{{ $t("sidebar.newSubmission.top") }}
            {{ $t("sidebar.newSubmission.bottom") }}</span
          >
        </v-tooltip>

        <v-list-item-content>
          <v-list-item-title class="d-flex flex-column"
            >{{ $t("sidebar.newSubmission.top")
            }}<span>{{
              $t("sidebar.newSubmission.bottom")
            }}</span></v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <!-- End profile -->

    <v-divider></v-divider>

    <!-- Navigation -->
    <v-list nav class="mt-7" v-if="$store.getters.hasAcceptedTerms">
      <v-list-item-group v-model="selectedItem" active-class="active-class">
        <v-list-item
          v-for="item in visibleItems"
          :key="item.title"
          :class="mini ? 'mx-5' : 'mx-7'"
          :to="item.path"
          link
        >
          <v-tooltip color="black" right :disabled="!mini">
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on">
                <v-icon large>{{ item.icon }}</v-icon>
              </v-list-item-icon>
            </template>
            <span>{{ $t(`sidebar.${item.title.toLowerCase()}`) }}</span>
          </v-tooltip>

          <v-list-item-content>
            <v-list-item-title>{{
              $t(`sidebar.${item.title.toLowerCase()}`)
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <!-- End navigation -->

    <!-- Close -->
    <template v-slot:append>
      <v-list nav>
        <v-list-item
          class="my-5"
          :class="mini ? 'mx-5' : 'mx-7'"
          @click="mini = !mini"
          link
        >
          <v-tooltip color="black" right :disabled="!mini">
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on">
                <v-icon large>{{
                  mini ? "mdi-arrow-collapse-right" : "mdi-arrow-collapse-left"
                }}</v-icon>
              </v-list-item-icon>
            </template>
            <span>{{ $t("sidebar.dropdown") }}</span>
          </v-tooltip>

          <v-list-item-content>
            <v-list-item-title>{{ $t("sidebar.dropdown") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          class="my-5"
          :class="mini ? 'mx-5' : 'mx-7'"
          link
          @click="logout"
        >
          <v-tooltip color="black" right :disabled="!mini">
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on">
                <v-icon large>mdi-logout-variant</v-icon>
              </v-list-item-icon>
            </template>
            <span>{{ $t("sidebar.logout") }}</span>
          </v-tooltip>

          <v-list-item-content>
            <v-list-item-title>{{ $t("sidebar.logout") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
    <!-- End close -->
  </v-navigation-drawer>
</template>

<script>
import * as Sentry from "@sentry/vue";
import user from "@/api/user";
export default {
  name: "Sidebar",
  data() {
    return {
      items: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard-outline",
          path: "/",
          roles: ["company-admin", "company-user", "superuser", "developer"],
        },
        {
          title: "History",
          icon: "mdi-text-box-search-outline",
          path: "/history",
          roles: ["company-admin", "company-user", "superuser", "developer"],
        },
        {
          title: "Team",
          icon: "mdi-account-hard-hat-outline",
          path: "/team",
          roles: ["company-admin"],
        },
        {
          title: "Companies",
          icon: "mdi-domain",
          path: "/companies",
          roles: ["superuser", "developer"],
        },
        {
          title: "Activities",
          icon: "mdi-bell-ring-outline",
          path: "/activities",
          roles: ["company-admin", "company-user", "superuser", "developer"],
        },
        {
          title: "Partners",
          icon: "mdi-handshake-outline",
          path: "/partners",
          roles: ["company-admin", "company-user", "superuser", "developer"],
        },
      ],
      drawer: true,
      mini: true,
      selectedItem: 0,
    };
  },
  methods: {
    async logout() {
      try {
        await user.logout();
        this.$store.commit("resetState");
        this.$router.push({ name: "Login" });
      } catch (error) {
        Sentry.captureException(error);
      }
    },
  },
  computed: {
    visibleItems() {
      const userRole = this.$store.getters.getUser.role;
      return this.items.filter((item) => item.roles.includes(userRole));
    },
  },
};
</script>

<style scoped>
.active-class-profile {
  color: white !important;
}
.active-class {
  background-color: black !important;
  color: white !important;
}

.v-navigation-drawer--mini-variant .v-list-item > *:first-child {
  margin-right: 0;
}

.v-navigation-drawer {
  height: 100dvh !important;
}
</style>
